import getData from './getData'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let cachedLocale: Record<string, any> | null = null
const translationCache: Record<string, string> = {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getLocale(): Record<string, any> {
  if (!cachedLocale) {
    cachedLocale = getData().locale
  }
  return cachedLocale
}

export function t(path: string, replace: Record<string, string> = {}): string {
  if (translationCache[path]) {
    return replacePlaceholders(translationCache[path], replace)
  }

  const locale = getLocale()
  const pathParts = path.split('.')
  let current = locale

  for (const part of pathParts) {
    current = current[part]
    if (current === undefined) {
      console.error(`Missing translation for ${path}`)
      return path
    }
  }

  if (typeof current !== 'string') {
    throw new Error(`Translation for ${path} is not a string`)
  }

  translationCache[path] = current
  return replacePlaceholders(current, replace)
}

function replacePlaceholders(template: string, replace: Record<string, string>): string {
  return template.replace(/{(\w+)}/g, (_, key) => (key in replace ? replace[key] : `{${key}}`) || '')
}
